/*
	Sometimes we want a field header for a set of associated fields without the overhead of
	having to make an entire custom component.

	This just mimics the field headers on Rhombus fields, where it will append an asterisk if
	the field is required, and change it to a checkmark when the value is valid.

	Example Usage:
	```
		function DisclaimerForm(props){
			const errors = useSelector(getFormSyncErrors(SOME_FORM));
			const isDisclaimerContentValid = !(errors.disclaimerText || errors.disclaimerUrl)

			return (
				<div>
					<GroupHeader
						required
						isValid={isDisclaimerContentValid}
					>
						Disclaimer Content
					</GroupHeader>
					<Field
						name = "disclaimerText"
						...
					/>
					<Field
						name = "disclaimerUrl"
						...
					</Field>
				</div>
			);
		}
	```
*/

import React from "react";

import "./GroupHeader.css";

export default function GroupHeader(props){
	const {
		required = false,
		isValid = true,
		children,
	} = props;

	const validClass = isValid ? "is-valid" : "has-error";

	return (
		<div className="group-header e-form__control-header">
			<div className={`e-form__control-label ${required ? validClass : ""}`}>
				{children}
			</div>
		</div>
	);
}

GroupHeader.displayName = "GroupHeader";
